import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import clinicAPI from "../../services/clinicApi";
import { PATIENTS_BASE } from "./AdminPatients/patientConstants";
import s from "./clinic.module.css";
import u from "../ui/ui.module.css";
import { Input, Avatar, IconSearch } from "../ui";

export default function GlobalPatientSearch({ className = "" }) {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!q.trim()) {
      setResults([]);
      setOpen(false);
      return;
    }
    const t = setTimeout(() => {
      setLoading(true);
      clinicAPI
        .searchPatients(q, 8)
        .then((r) => {
          setResults(r.patients || []);
          setOpen(true);
        })
        .catch(() => setResults([]))
        .finally(() => setLoading(false));
    }, 280);
    return () => clearTimeout(t);
  }, [q]);

  useEffect(() => {
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const go = (id) => {
    setOpen(false);
    setQ("");
    navigate(`${PATIENTS_BASE}/${id}`);
  };

  return (
    <div className={`${s.globalSearch} ${className}`.trim()} ref={wrapRef}>
      <IconSearch className={s.globalSearchIcon} width={18} height={18} />
      <Input
        className={s.globalSearchInput}
        placeholder="Поиск клиента: ФИО, телефон, email…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onFocus={() => q.trim() && results.length && setOpen(true)}
      />
      {open && (results.length > 0 || loading) ? (
        <ul className={s.globalSearchDropdown} role="listbox">
          {loading ? (
            <li className={s.globalSearchEmpty}>Поиск…</li>
          ) : (
            results.map((p) => (
              <li key={p.id}>
                <button
                  type="button"
                  className={s.globalSearchItem}
                  onClick={() => go(p.id)}
                >
                  <Avatar name={p.full_name} size="sm" />
                  <div className={s.globalSearchItemText}>
                    <span className={s.globalSearchItemName}>
                      {p.full_name || "Без имени"}
                    </span>
                    <span className={s.globalSearchItemMeta}>
                      {p.patient_card?.card_number || "—"} ·{" "}
                      {p.phone || p.email || ""}
                    </span>
                  </div>
                  {p.is_blocked ? (
                    <span className={`${u.badge} ${u.badgeRed}`}>Блок</span>
                  ) : null}
                </button>
              </li>
            ))
          )}
        </ul>
      ) : null}
    </div>
  );
}
